export default {
    intro: '뒤섞인 문장들을 올바른 순서로 맞춰 보세요!',
    indicator: ({ values }: { values: { isAllDone: boolean } }) => {
        const { isAllDone } = values;
        if (isAllDone) {
            return '완성된 글을 다시 한번 읽어보세요.';
        }
        return '문장들의 순서를 올바르게 맞춰보세요!';
    },
};
